import React, { useEffect, useState } from "react";
import { X, Sparkles, ArrowRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { trackPreEnrollmentClick } from "../lib/analytics";

const WA = "https://wa.me/524421182816?text=" +
  encodeURIComponent("Hola, quiero información sobre inscripciones");

const SummerBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem("stepsSummerBannerClosed") === "1") setVisible(false);
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty("--banner-h", visible ? "44px" : "0px");
    return () => document.documentElement.style.setProperty("--banner-h", "0px");
  }, [visible]);

  const close = () => {
    sessionStorage.setItem("stepsSummerBannerClosed", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="summer-banner"
      className="fixed top-0 left-0 right-0 z-[60] w-full h-11 bg-gradient-to-r from-[#2E9E4E] via-[#4FCB6A] to-[#FF8A33] text-white shadow-md"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-full flex items-center gap-3 md:gap-5">
        <div className="hidden sm:flex items-center justify-center w-9 h-9 rounded-full bg-[#FFD500] shrink-0 ring-2 ring-white/40">
          <Sparkles className="w-5 h-5 text-[#1D3557]" strokeWidth={2.5} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs md:text-sm leading-tight">
            <span className="font-fredoka text-[#FFD500] font-bold mr-1.5 drop-shadow-sm">{t.summer.bannerBrand}</span>
            <span className="hidden md:inline text-white/90">·</span>
            <span className="ml-1.5 text-white font-medium">{t.summer.bannerHighlight}</span>
          </p>
          <p className="text-[10px] md:text-xs text-white/85 mt-0.5 hidden sm:block">
            {t.summer.bannerSub}
          </p>
        </div>
        <a
          data-testid="summer-banner-cta"
          href="#contacto"
          onClick={() => trackPreEnrollmentClick("banner")}
          className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-[#FFD500] text-[#1D3557] px-3 md:px-4 py-1.5 text-xs md:text-sm font-bold hover:bg-white hover:scale-105 transition-all shrink-0 shadow-md"
        >
          {t.summer.bannerCta}
          <ArrowRight className="w-3.5 h-3.5" strokeWidth={2.5} />
        </a>
        <a
          data-testid="summer-banner-cta-mobile"
          href="#contacto"
          onClick={() => trackPreEnrollmentClick("banner_mobile")}
          className="sm:hidden inline-flex items-center rounded-full bg-[#FFD500] text-[#1D3557] px-3 py-1.5 text-xs font-bold shrink-0"
        >
          Info
        </a>
        <button
          data-testid="summer-banner-close"
          onClick={close}
          aria-label="Cerrar"
          className="shrink-0 p-1 rounded hover:bg-white/10 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default SummerBanner;
